/*
 * @Author: Veto [关于心伴部分 路由]
 * @Date: 2023-12-26 16:08:20 
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2024-01-16 18:47:10
 */

import Privacy from '../views/gaga/privacy.vue';
import DeleteAccount from '../views/gaga/delete.vue';
import Download from '../views/gaga/download.vue';


const router = {
    '/gaga-privacy': Privacy,
    '/delete-account': DeleteAccount,
    '/gaga-d': Download
};


export default router;